// extracted by mini-css-extract-plugin
module.exports = {"news-tag":"e_","newsTag":"e_","dafalut":"fa","qishou":"fb","shangjia":"fc","shehui":"fd","caiwu":"fe","piyao":"ff","suanfa":"fg","keji":"fh","lingshou":"fi","gongzuo":"fj"};